import React, { FC } from 'react';

type TTerritoryTabListItemProps = {
  children: React.ReactNode;
  onClick?: () => void;
};

export const TerritoryTabListItem: FC<TTerritoryTabListItemProps> = ({ children, onClick }) => (
  <li onClick={onClick} className="cursor-pointer">
    {children}
  </li>
);
